<template>
	<div style="width:90%">
		<div class="container_body">
			<header class="header_nav">
				<el-form :inline="true" class="demo-form-inline" :model="searchInfo" style="margin: 20px 0px 0px 20px;">
					<el-form-item>
						<template>
							<el-form-item label="用户名称:" class='tiny' cleartable>
								<el-input style="width: 200px;" v-model="searchInfo.username" placeholder="请输入"></el-input>
							</el-form-item>
							<el-form-item label="状态:" class='tiny' cleartable>
								<el-select v-model="searchInfo.status" placeholder="请选择">
									<el-option key="-1" label="全部" value="">全部</el-option>

									<el-option label="待处理" :value="0"></el-option>
									<el-option label="处理中" :value="1"></el-option>
									<el-option label="已解决" :value="2"></el-option>
								</el-select>
							</el-form-item>
							<el-button type="primary" @click="search">搜索</el-button>
	                        <el-button @click="empty">清空</el-button>
							<!-- <el-button type="primary" @click="editialogVisible('')">新增
							</el-button> -->
						</template>
					</el-form-item>
				</el-form>
			</header>
		</div>


		<el-table :data="feedbackNodeList.list" stripe style="width: 100%;" :header-cell-style="headClass"
			v-loading="loading" element-loading-text="拼命加载中" element-loading-spinner="el-icon-loading">
			<el-table-column prop="typeName" label="类型名称" align="center" :show-overflow-tooltip="true">
			</el-table-column>

			<el-table-column prop="typeImg" label="类型图标" align="center" :show-overflow-tooltip="true">
				<template slot-scope="scope">
					<img v-if="scope.row.typeImg" :src="scope.row.typeImg" width="50px" @click="open(scope.row.typeImg)" />
					<div v-else> 暂无图片 </div>
				</template>
			</el-table-column>

			<el-table-column prop="username" label="用户名" align="center" :show-overflow-tooltip="true">
			</el-table-column>

			<el-table-column prop="logo" label="用户头像" align="center" :show-overflow-tooltip="true">
				<template slot-scope="scope">
					<div v-if="scope.row.logo" @click="open(scope.row.logo)">
						<el-avatar :size="50" :src="scope.row.logo"></el-avatar>
					</div>
					<div v-else> 暂无头像 </div>
				</template>
			</el-table-column>

			<el-table-column prop="createDate" label="最初反馈回复时间" align="center">
			</el-table-column>

			<el-table-column prop="content" label="最初反馈回复内容" align="center" :show-overflow-tooltip="true">
			</el-table-column>

			<el-table-column prop="fbImg" label="最初反馈图片" align="center" :show-overflow-tooltip="true">
				<template slot-scope="scope">
					<img v-if="scope.row.fbImg" :src="scope.row.fbImg" width="50px" @click="open(scope.row.fbImg)" />
					<div v-if="!scope.row.fbImg"> 暂无图片 </div>
				</template>
			</el-table-column>

			<el-table-column prop="pcreateDate" label="最新反馈回复时间" align="center">
			</el-table-column>

			<el-table-column prop="pcontent" label="最新反馈回复内容" align="center" :show-overflow-tooltip="true">
			</el-table-column>

			<el-table-column prop="status" label="状态" align="center">
				<template slot-scope="scope">
					<p v-if="scope.row.status == 0">未处理</p>
					<p v-if="scope.row.status == 1">处理中</p>
					<p v-if="scope.row.status == 2">已处理</p>
				</template>
			</el-table-column>
			<el-table-column  label="操作"  fixed="right" align="center">
				　　<template slot-scope="scope">
					<el-button size="small" type="text" @click="editialogVisible(scope.row.id)">回复</el-button>

					<el-button v-if="scope.row.status == 2" size="small" type="text"></el-button>
					<el-button v-else size="small" type="text" @click="processed(scope.row.id)">处理完成</el-button>
				</template>
			</el-table-column>
		</el-table>
		<el-pagination style="margin: 20px;" background :current-page="feedbackNodeList.pageNum"
			@current-change="pageChange" layout="total, sizes, prev, pager, next, jumper" :total="feedbackNodeList.total"
			@size-change="handleSizeChange">
		</el-pagination>

		<!-- 查看 -->
		<el-dialog title="提示" :visible.sync="showContentDialog" width="50%">
			<span v-html="contentValue"></span>
			<span slot="footer" class="dialog-footer">
				<el-button type="primary" @click="showContentDialog = false">确 定</el-button>
			</span>
		</el-dialog>

		<!-- 编辑 -->
		<el-dialog style="float:rigin" title="回复" :visible.sync="editDialogVisible" width="50%" :close-on-click-modal="false">
			<div style="height: 500px;overflow-x:hidden;overflow-y: scroll;">
				<div v-for="(feedback,index) in feedbackList.list" :key="index">

					<div class="block" style="display: flex;justify-content: flex-start;margin: 16px;" v-if="feedback.userId">
						<el-avatar v-if="feedback.logo != null" :size="50" :src="feedback.logo"></el-avatar>
						<el-avatar v-if="feedback.logo == null" :size="50"
							:src="'https://cube.elemecdn.com/0/88/03b0d39583f48206768a7534e55bcpng.png'"></el-avatar>
						<div class="atalk">
							<div style="margin-bottom:10px ;">{{feedback.createDate}} <br />{{feedback.username}}</div>
							<span id="asay">
								{{feedback.content}}
								<br />
								<img v-if="feedback.fbImg" width="140px" :src="feedback.fbImg" style="margin: 10px;"
									@click="open(feedback.fbImg)" />
							</span>
						</div>
					</div>

					<div class="block" style="display: flex;justify-content: flex-end;margin: 16px;" v-else>
						<div class="btalk">
							<div style="margin-bottom:10px ;">{{feedback.createDate}} <br />反馈小助手</div>
							<span id="asay">
								{{feedback.content}}
								<br />
								<img v-if="feedback.fbImg" width="140px" :src="feedback.fbImg" style="margin: 10px;"
									@click="open(feedback.fbImg)" />
							</span>
						</div>
						<el-avatar :size="50" :src="'https://cube.elemecdn.com/0/88/03b0d39583f48206768a7534e55bcpng.png'">
						</el-avatar>
					</div>

				</div>
			</div>

			<div style="width: 100%; margin-top: 10px;">
				<div style="display: flex;justify-content: center;align-items: center;width: 100%;">

					<div style="margin-right: 20px;">
						<el-upload class="upload-demo" :action="migUrls" :on-preview="handlePreview" :on-success="onSuccess"
							:on-remove="handleRemove" :before-remove="beforeRemove" multiple :on-exceed="handleExceed"
							:show-file-list="false">
							<el-button size="small" type="primary">发送图片</el-button>
							<!-- <div slot="tip" class="el-upload__tip">只能上传jpg/png文件，且不超过500kb</div> -->
						</el-upload>
					</div>

					<div style="padding-right: 20px;width: 100%;">
						<el-input style="width: 100%;" v-model="content" placeholder="请输入内容"></el-input>
					</div>
					<div>
						<el-button type="primary" @click="reply">回复</el-button>
					</div>
				</div>
			</div>

			<el-pagination style="margin: 20px;" background :current-page="feedbackList.pageNum" @current-change="pageChanges"
				layout="total, sizes, prev, pager, next, jumper" :total="feedbackList.total" @size-change="handleSizeChanges">
			</el-pagination>

		</el-dialog>

		<el-dialog title="图片详情" :visible.sync="imgDialogVisible" width="60%">
			<img :src="imgUrl" width="80%" style="margin: 10px;" />
			<span slot="footer" class="dialog-footer">
				<el-button type="primary" @click="imgDialogVisible = false">关 闭</el-button>
			</span>
		</el-dialog>

	</div>
</template>

<script>
	import { uploadFileServer } from '@/api/axios.js'
	var urls = uploadFileServer('queryFeed');

	import {
		quillEditor
	} from 'vue-quill-editor' //调用编辑器
	import 'quill/dist/quill.core.css'
	import 'quill/dist/quill.snow.css'
	import 'quill/dist/quill.bubble.css'

	export default {
		components: {
			//使用编辑器
			quillEditor
		},
		data() {
			return {
				migUrls: urls,
				imgUrl: '',
				imgDialogVisible: false,
				content: '',
				//fileList: [],
				loading: false,
				feedbackNodeList: [], //消息类型列表
				feedbackList: [],
				dialogVisible: false,
				editDialogVisible: false,
				form: {
					id: 0,
					code: "",
					typeName: "",
					typeNameEn: "",
					typeImg: ""
				},
				mainFormRules: {
					title: {
						required: true,
						message: "请输入账号",
						trigger: "blur"
					},
				},
				integralList: [],
				integralId: "", //积分id
				appropriation: "",
				ids: '', //授权用户id
				userData: [{}], //用户角色列表
				userDataList: [], //用户角色列表选中的
				formLabelWidth: "200px",
				page: {
					pageNum: 1,
					pageSize: 10
				},
				page1: {
					pageNum: 1,
					pageSize: 10
				},
				searchInfo: {
					status: '',
				},
				index: null,
				contentValue: "",
				showContentDialog: false
			};
		},
		computed: {
			editor() {
				return this.$refs.myQuillEditor.quill
			}
		},
		methods: {
			open(imgUrl) {
				// console.log(imgUrl)
				// console.log(this.imgDialogVisible)
				this.imgUrl = imgUrl;
				this.imgDialogVisible = true;
			},
			handleRemove(file, fileList) {
				//console.log(file, fileList);
			},
			handlePreview(file) {
				//console.log(file);
			},
			handleExceed(files, fileList) {
				this.$message.warning(`当前限制选择 1 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`);
			},
			beforeRemove(file, fileList) {
				return this.$confirm(`确定移除 ${file.name}？`);
			},
			onSuccess(response, file, fileList) {
				// console.log(response);
				var data = {
					pid: this.ids,
					fbImg: response.message
				}
				this.$api.addFeedbackNode(data).then((res) => { //回复
					// console.log(res);
					if (res.state == 'success') {
						this.content = ''; //清空输入框

						this.getFeedbackList(this.page1); //查询反馈详情
					}
					this.$message({
						message: res.message,
						type: 'success'
					});
				})
			},
			empty() {
				this.searchInfo = {}
			},
			search() {
				this.page.pageNum = 1;
				this.getFeedbackNodeList();
			},
			showContent(content) {
				this.contentValue = content
				this.showContentDialog = true
			},
			//编辑弹框
			editialogVisible(id) {
				this.fileList = []
				if (id) {
					this.fileList = []
					//编辑查询
					this.ids = id
					this.form.timer = []

					this.page1 = {
						pageNum: 1,
						pageSize: 10,
						pid: id
					}
					this.getFeedbackList(this.page1); //查询反馈详情
				} else {
					this.ids = ""
					this.form = {}
				}
				this.editDialogVisible = true;
			},
			reply() {
				var data = {
					pid: this.ids,
					content: this.content
				}
				// console.log(data)
				this.$api.addFeedbackNode(data).then((res) => { //回复
					// console.log(res);
					if (res.state == 'success') {
						this.content = ''; //清空输入框

						this.getFeedbackList(this.page1); //查询反馈详情
					}
					this.$message({
						message: res.message,
						type: 'success'
					});
				})
			},
			getFeedbackList(page) {
				this.$api.findByWhereFeedback(page).then((res) => {
					if (res.state == 'success') {
						this.feedbackList = res.data;
					}
				})
			},
			pageChanges(data) {
				this.page1.pageNum = data
				this.getFeedbackList(this.page1)
			},
			handleSizeChanges(val) {
				this.page1.pageSize = val
				this.getFeedbackList(this.page1)
			},
			headClass() {
				return 'text-align:center;background:#E6E9F0;color: rgb(31, 46, 77);height:56px'
			},
			formartStartDate(row, column) {
				var ymdhis = "";
				if (row) {
					var time = new Date(row.startDate);
					ymdhis += time.getFullYear() + "-";
					ymdhis += ((time.getMonth() + 1) < 10 ? '0' + (time.getMonth() + 1) : (time.getMonth() + 1)) + "-";
					ymdhis += (time.getDate() < 10 ? '0' + time.getDate() : time.getDate()) + ' ';
					ymdhis += (time.getHours() < 10 ? '0' + time.getHours() : time.getHours()) + ":";
					ymdhis += (time.getMinutes() < 10 ? '0' + time.getMinutes() : time.getMinutes()) + ":";
					ymdhis += (time.getSeconds() < 10 ? '0' + time.getSeconds() : time.getSeconds());
					return ymdhis;
				} else {
					return '无';
				}
			},
			formartDate(row, column) {
				var ymdhis = "";
				if (row) {
					var time = new Date(row.endDate);
					ymdhis += time.getFullYear() + "-";
					ymdhis += ((time.getMonth() + 1) < 10 ? '0' + (time.getMonth() + 1) : (time.getMonth() + 1)) + "-";
					ymdhis += (time.getDate() < 10 ? '0' + time.getDate() : time.getDate()) + ' ';
					ymdhis += (time.getHours() < 10 ? '0' + time.getHours() : time.getHours()) + ":";
					ymdhis += (time.getMinutes() < 10 ? '0' + time.getMinutes() : time.getMinutes()) + ":";
					ymdhis += (time.getSeconds() < 10 ? '0' + time.getSeconds() : time.getSeconds());
					return ymdhis;
				} else {
					return '无';
				}

			},
			pageChange(data) {
				this.page.pageNum = data
				this.getFeedbackNodeList()
			},
			handleSizeChange(val) {
				this.page.pageSize = val
				this.getFeedbackNodeList()
			},
			getFeedbackNodeList() {
				this.loading = true
				let data = {
					pageNum: this.page.pageNum,
					pageSize: this.page.pageSize,
					username: this.searchInfo.username,
					status: this.searchInfo.status
				}
				this.$api.findByWhereFeedbackNode(data).then((res) => { //反馈节点
					// console.log(res);
					if (res.state == 'success') {
						this.feedbackNodeList = res.data
						this.loading = false
					}
				})
			},
			//已处理
			processed(id) {
				var data = {
					id: id,
					status: 2
				}
				this.$confirm('请确认反馈建议已处理完成, 是否继续?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.$api.upStatusFeedbackNode(data).then((res) => {
						if (res.state == 'success') {
							this.$message({
								message: res.message,
								type: 'success'
							});
							this.getFeedbackNodeList();
						} else {
							this.$message.error(res.message);
						}
					})
				}).catch(() => {
					this.$message({
						type: 'info',
						message: '已取消'
					});
				});
				
			}
		},
		created() {
			this.getFeedbackNodeList();
		},
		mounted: function () { },
	};
</script>

<style>
	.demo-table-expand {
		font-size: 0;
		margin-left: 30px;
	}

	.demo-table-expand label {
		width: 100px;
		color: #99a9bf;
	}

	.demo-table-expand .el-form-item {
		margin-right: 0;
		margin-bottom: 0;
		width: 50%;
	}

	.lpc-quill img {
		width: 100px;
		height: 120px;
	}

	.lpc-quill-en img {
		width: 100px;
		height: 120px;
	}

	.talk_con {
		width: 600px;
		height: 500px;
		border: 1px solid #666;
		margin: 50px auto 0;
		background: #f9f9f9;
	}

	.talk_show {
		width: 580px;
		height: 420px;
		border: 1px solid #666;
		background: #fff;
		margin: 10px auto 0;
		overflow: auto;
	}

	.talk_input {
		width: 580px;
		margin: 10px auto 0;
	}

	.whotalk {
		width: 80px;
		height: 30px;
		float: left;
		outline: none;
	}

	.talk_word {
		width: 420px;
		height: 26px;
		padding: 0px;
		float: left;
		margin-left: 10px;
		outline: none;
		text-indent: 10px;
	}

	.talk_sub {
		width: 56px;
		height: 30px;
		float: left;
		margin-left: 10px;
	}

	.atalk {
		margin: 10px;
	}

	.atalk span {
		display: inline-block;
		background: #0181cc;
		border-radius: 10px;
		color: #fff;
		padding: 5px 10px;
	}

	.btalk {
		margin: 10px;
		text-align: right;
	}

	.btalk span {
		display: inline-block;
		background: #ef8201;
		border-radius: 10px;
		color: #fff;
		padding: 5px 10px;
	}
</style>